export default {
  // Режимдер
  "common.mode.auto": "Автоматтык режим (өзегіңіздің электр энергясын қолдану)",
  "common.mode.economy": "Экономикалық режим",
  "common.mode.exigency": "Түпкіш режим",

  // Құрылғылар
  "common.grid": "Электр желі",
  "common.evChargers": "Электр көліктердің зарядғылары (көптеген)",
  "common.evCharger": "Электр көліктің зарядғылы",
  "common.pv": "Карапайым энергия (PV)",
  "common.inverter": "Инвертер ( τάуышты өзгертүү құрылғысы)",
  "common.pcs": "Инвертер + батарейя",
  "common.terminal": "Терминал құрылғысы",
  "common.airc": "Ауа қустыру құрылғысы (AC)",
  "common.engine": "Өңгірі",
  "common.battery": "Батарейя",
  "common.metter": "Электрлік есепші",
  "common.other": "Басқалар",
  "common.power": "Куат",
  "common.powerTotal": "Жалпы қуат",
  "common.voltage": "Т τάуышы",
  "common.electricity": "Электр",
  "common.current": "Қырғы",
  "common.homeUsage": "Әйдіне жалпы жүктемесі",
  "common.battery.power": "Батарейяның қуаты",

  // Данные
  "common.noDataAvailable": "Қазір деректер қол жетімді емес~",
  "common.tips": "Көмектесулер",
  "common.reset": "Тазарту (түзету)",
  "common.currencyUnit": "¥ (юань)",
  "common.submiting": "Жіберілуда... сәл кейініші күте тұрыңыз...",
  "common.close": "Жабу",
  "common.from": "Ден",
  "common.useIn": "Көрсету үшін",
  "common.energyPercent": "Энергия пайдалану дүниесі",
  "common.dataFlow": "Деректер ағыны",
  "common.getDataIng": "Деректерді алуда... сәл кейініші күте тұрыңыз...",
  "common.pageLoading": "Бет жүктелуде... сәл кейініші күте тұрыңыз...",
  "common.reseting": "Бетті тазартуда... сәл кейініші күте тұрыңыз...",
  "common.save": "Сақтау",
  "common.onlyNumberTips": "Тек санларды енгізі аласыз",
  "common.offline": "Оффлайн (интернетке қосылмаған)",
  "common.online": "Онлайн (интернетке қосылған)",
  "common.fault": "Қате (проблема)",
  "common.charge": "Зарядтау (батарейя)",
  "common.discharge": "Тіркеу (батарейя энергясын қолдану)",
  "common.buy": "Сатып алу",
  "common.sell": "Сату",
  "common.loadingInfo": "Жүктелуде... сәл кейініші күте тұрыңыз...",

  // Жалпы функциялар
  "common.moreFeatures": "Қосымша мүмкіндіктер",
  "common.confirm": "Рақымдау",
  "common.saveing": "Сақталуде... сәл кейініші күте тұрыңыз...",
  "common.searchPlacholder": "Іздеу кілті сөзін енгізіңіз",
  "common.iSee": " түсіндім",
  "common.pageErrorTips1": "Ой, бетте қате пайда болды~",
  "common.pageErrorTips2": "Бетті жаңартыңыз немесе қолдаумен байланысыңыз~",
  "common.refresh": "Жаңарту",
  "common.backToHome": "Басты бетке қайтару",
  "common.checkTips": "Тексеруде... сәл кейініші күте тұрыңыз...",
  "common.back": "Қайтару",
  "common.cancel": "Бағдарламаны тоқтату (өшіру)",
  "common.optional": "Қолайлы (мәжбүр емес)",
  "common.required": "Енгізуге мәжбүр",
  "common.status": "Күй",
  "common.statusNoDelete": "Өшірілмеген",
  "common.statusDelete": "Өшірілген",
  "common.submit": "Жіберу",
  "common.disable": "Өлдіру",
  "common.enable": "Активдеу",
  "common.year": "Жыл",
  "common.month": "Ай",
  "common.day": "Күн",
  "common.version": "Нұсқасы:",
  "common.backHome": "Басты бетке қайтару",
  "common.backHomeSorry": "Кешіріңіз, бұл бет жарамсыз",
  "common.requestTips1": "Деректерді алу жалғастырады, қайтадан жіберуңізді жою",
  "common.requestTips2": "Система хабарларының",
  "common.requestTips3": "Кіру сессиясы аяқталды, қайтадан кіріңіз",
  "common.requestTips4": "Қайтадан кіру",
  "common.requestTips5": "Кіру жарамсыз немесе сессия аяқталды, қайтадан кіріңіз.",
  "common.requestTips6": "Серверде қате болды, кейінше қайталап көріңіз.",
  "common.requestTips7": "Система сұрауы мерзімі аяқталды",
  "common.requestTips8": "Система интерфейсі",
  "common.requestTips9": "Қате",
  "common.iknow": " түсіндім",
  "common.logoutSuccess": "Сәтті шығыл",
  
  // Детальді ақпарат бөлігі
  "common.knowMore.title": "Детальді ақпарат үшін Beineng bilan байланысыңыз",
  "common.knowMore.email": "Байланыс үшін электроны пошта",
  "common.knowMore.phone": "Байланыс үшін телефон нөмірі",
  "common.knowMore.wechat": "Байланыс үшін Вэчат",
  "common.knowMore.website": "Рұқсатты веб-сайт адресі",
  "common.knowMore.address": "Байланыс үшін мекен-жай",
  "common.knowMore.addressDetail": "Гуандун облығы, Дунган шаҳарында, Хуанҗян округінде, Хуанҗинкэнг ауылында, Чинкси 8 көшесі, 5 ғимаратта, 1205, 1301 бөлме",
  
  // Локальный қосылым
  "common.localConnection": "Локальный қосылым",
  "common.operateInApp": "Операцияларды қосымшадан орындаңыз!",
  
  "common.enbleStaus": "Активдүү күй",
  "common.battery.status": "Зарядталмайды, тіркелмейді",

  // Акаунттерге байланысты
  "account.forgetThePassword": "Құпиясөзді ұмытып кеттіңіз бе",
  "account.logInDirectly": "Тұрақты кірүү",
  "account.tips1": "Бетке keçу드ә... сәл кейініші күте тұрыңыз...",
  "account.tips2": "Алдымен пайдалану шартларын оқып, рақымдаңыз!",
  "account.autoLogin": "Автоматтык кірүү",
  "account.userLogin": "Пайдаланушының кірүүі",
  "account.registerTips": "Акаунтыңыз жоқ па? Тіркелудің үшін осында басыңыз",
  "account.userEmail": "Пайдаланушы аты / электроны пошта",
  "account.userEmailTips": "Пайдаланушы аты немесе электроны поштаны енгізіңіз",
  "account.password": "Құпиясөз",
  "account.passwordTips": "Құпиясөзді енгізіңіз",
  "account.submit": "Жіберу",
  "account.submitTips": "Жіберілуда... сәл кейініші күте тұрыңыз...",
  "account.otherLoginTips": "Елде басқа кірүү тәсілін таңдаңыз",
  "account.userRegistration": "Пайдаланушының тіркелуі",
  "account.userName": "Пайдаланушы аты",
  "account.userNameTips": "Пайдаланушы атын енгізіңіз",
  "account.emailTips1": "Электрондық пошта адресін енгізіңіз",
  "account.emailTips2": "Жарамсыз электроны пошта форматы",
  "account.phone": "Телефон",
  "account.phoneTips1": "Телефон нөмірін енгізіңіз",
  "account.phoneTips2": "Жарамсыз телефон нөмірі",
  "account.phoneTips3": "Телефон нөмірін енгізіңіз",
  "account.passwordTips1": "Құпиясөзді енгізіңіз (6-30 таңба)",
  "account.passwordTips2": "Жарамсыз құпиясөз форматы: құпиясөзде латын әріптері, сандар, асттагы сызық (_), сызық (-) және nöқта (.) болуы керек, ұзындығы 6-12 таңба",
  "account.passwordTips3": "Енгізілген екі құпиясөз сәйкес келмейді, тексеріп, қайтадан енгізіңіз!",
  "account.passwordTips4": "Құпиясөзді енгізіңіз: құпиясөзде латын әріптері, сандар, асттагы сызық (_), сызық (-) және nöқта (.) болуы керек",
  "account.passwordTips5": "Құпиясөзді рақымдау",
  "account.passwordTips6": "Құпиясөзді рақымдау үшін енгізіңіз",
  "account.passwordTips7": "Енгізілген екі құпиясөз сәйкес келмейді, тексеріп, қайтадан енгізіңіз!",
  "account.passwordTips8": "Құпиясөзді рақымдау үшін енгізіңіз",
  "account.passwordTips9": "Қуайыптымыз, тіркелу сәтті аяқталды!",
  "account.passwordTips10": "Сіздің пайдаланушы атыңыз:",
  "account.emailIs": "Сіздің электроны поштаңыз:",
  "account.goToLoginPage": "s секундтан кейін автоматты түрде кірүү бетinə өтіледі",
  "account.goLogin": "Кіру",
  "account.goRegister": "Тіркелу",
  "account.loginSuccess": "Кіру сәтті",
  "account.email": "Электрондық пошта",
  "account.sologn": "Біз сіз үшін арнайы дайындалған интегралды энергетика платформасын жасаймыз",
  "account.pleaseAgree": "Пайдалану шартларын оқып, рақымдадым",
  "userAgreement.privacyPolicy": "Құпиялылық саясаты",

  // Рақымдау кодыне байланысты
  "account.code": "Рақымдау кodu",
  "account.codeTips": "Рақымдау кодын енгізіңіз",
  "account.codeTips2": "Жарамсыз рақымдау кodu",

    "account.inviteCodeTips": "Шақыру кодын енгізіңіз",
    "account.inviteCodeHint": "Шақыру кодын алу үшін орнатушыға немесе техникалық қызмет көрсету қызметкерлеріне хабарласыңыз",
  // Құпиясөзді өзгерту және қалпына келтіру
  "account.modifyPasswordByAccount": "Акаунт арқылы құпиясөзді өзгерту",
  "account.modifyPasswordByEmail": "Электрондық пошта арқылы құпиясөзді өзгерту",
  "account.getPasswordByAccount": "Акаунт арқылы құпиясөзді алу",
  "account.getPasswordByEmail": "Электрондық пошта арқылы құпиясөзді алу",

  "account.sendEmailTips": "Рақымдау кodu электроны поштаға жіберілді, тексерңіз",
  "account.name": "Акаунт аты",
  "account.newPassword": "Жаңа құпиясөз",
  "account.confirmNewPassword": "Жаңа құпиясөзді рақымдау",
  "account.nameTips": "Акаунт атын енгізіңіз",
  "account.passwordModifySuccess": "Құпиясөзді өзгерту сәтті",
  "account.emailCode": "Электрондық пошта рақымдау кodu",
  "account.emailCodeTips": "Электрондық пошта рақымдау кодын енгізіңіз",
  "account.emailCodeTips2": "Жарамсыз электроны пошта рақымдау кodu",
  "account.emailModifySuccess": "Құпиясөзді өзгерту сәтті",
  "account.passworTips1": "Сіздің құпиясөзіңіз қалпына келтірілді!",
  "account.passwordTips11": "Құпиясөзді рақымдау үшін енгізіңіз",
  "account.passwordTips12": "Жаңа құпиясөзді енгізіңіз",
  "account.nickname": "Ыстық аты",
  "account.modifyNickname": "Ыстық атыны өзгерту",
  "account.modifyNicknameSuccess": "Ыстық атыны өзгерту сәтті!",
  "account.nicknameTips": "Ыстық атын енгізіңіз",
  "account.nicknameError": "Ыстық атыны өзгерту сәтсіз!",

  // Тез тіркелу және кірүү
  "account.login": "Кіру",
  "account.quickRegister": "Тез тіркелу",
  "account.sendCode": "Код жіберу",
  "account.sendTips": "s секундтан кейін қайтадан жіберуге болады",
  "account.sendEmailIng": "Электрондық пошта жіберілуда... сәл кейініші күте тұрыңыз...",
  "account.emailNotEmpty": "Электрондық пошта өрісі бос болмауы керек",
  "account.registerAccount": "Акаунт тіркелу",
  "account.registerWelcome": "SusprSafe тіркелуіне қош келдіңіз",
  "account.usernameLimit": "Пайдаланушы аты әріпмен басталуы керек, тек әріптер, сандар және асттагы сызық (_) պекірілуі мүмкін, ұзындығы 5-15 таңба",

  // Авторлық құқық ақпараты
  "copyright.desc2": "Веб-сайт тіркеу ақпараты: Гуандун облығының ICP тіркеу нөмірі 2021169764",

  // Пайдаланушы ақпараттарын өңдеу
  "editUserInfo.editUserInformation": "Пайдаланушы ақпараттарын өңдеу",
  "editUserInfo.modifyUsername": "Пайдаланушы атын өзгерту",
  "editUserInfo.changePictures": "Профиль суретін өзгерту",
  "editUserInfo.savePicturesSuccess": "Профиль суретін сақтау сәтті",
  "editUserInfo.saveError": "Сақтау сәтсіз",
  "editUserInfo.pictureLimit": "Сурет өлшемі 2MB-ден асып кетемейді",
  "editUserInfo.uploadPicture": "Профиль суретін жүктеу",
  "editUserInfo.picturePreview": "Қарастыру",
  
  "editUserInfo.bindPhoneNumber": "Телефон нөмірін байланыстыру",
  "editUserInfo.bindEmail": "Электрондық поштаны байланыстыру",
  "editUserInfo.changePassword": "Құпиясөзді өзгерту",

  "editUserInfo.notificationSettings": "Хабарлау баптаулар",
  "editUserInfo.editAccount": "Акаунт ақпараттарын өңдеу",
  "editUserInfo.waitBingting": "Байланыстыруда... сәл кейініші күте тұрыңыз...",
  "editUserInfo.collapse": "Қысу ( ажырату)",
  "editUserInfo.modifyBinding": "Байланысты өзгерту",
  
  "editUserInfo.emailAddress": "Электрондық пошта адресі",
  "editUserInfo.tips1": "Электрондық поштаны байланыстыру сәтті",
  "editUserInfo.tips2": "Сақтау сәтсіз",
  "editUserInfo.tips3": "Электрондық пошта рақымдау кodu жіберілуда... сәл кейініші күте тұрыңыз...",
  "editUserInfo.tips4": "Рақымдау кodu xxxx электроны поштаға жіберілді, тексерңіз",
  "editUserInfo.tips5": "Рақымдау кodu жіберу сәтсіз!",
  "editUserInfo.tips6": "Телефон нөмірі байланыстырылды",
  "editUserInfo.tips7": "Электрондық пошта байланыстырылды",
  "editUserInfo.emailTips1": "Электрондық пошта адресін енгізіңіз",
  "editUserInfo.emailTips2": "Жарамсыз электроны пошта форматы",
  "editUserInfo.emailTips3": "xxxx секундтан кейін қайтадан жіберуге болады",
  "editUserInfo.emailTips4": "Код жіберу",
  "editUserInfo.emailTips5": "Электрондық пошта рақымдау коды өрісі бос болмауы керек",
  "editUserInfo.emailTips6": "Жарамсыз электроны пошта рақымдау кodu",
  "editUserInfo.emailCode": "Электрондық пошта рақымдау кodu",
  "editUserInfo.save": "Сақтау",

  // Телефон байланыстыруға байланысты
  "editUserInfo.phoneTips1": "Телефон нөмірін байланыстыру сәтті",
  "editUserInfo.phoneTips2": "SMS рақымдау кodu жіберілуда... сәл кейініші күте тұрыңыз...",
  "editUserInfo.phoneTips3": "SMS рақымдау кodu xxxx нөмірге жіберілді, тексерңіз",
  "editUserInfo.phoneTips4": "SMS рақымдау кodu жіберу сәтсіз!",
  "editUserInfo.phoneTips5": "Телефон нөмірін енгізіңіз",
  "editUserInfo.phoneTips6": "Жарамсыз телефон нөмірі форматы",
  "editUserInfo.phoneTips7": "SMS Код жіберу",
  "editUserInfo.phoneTips8": "SMS рақымдау кodu",
  "editUserInfo.phoneTips9": "SMS рақымдау коды өрісі бос болмауы керек",
  "editUserInfo.phoneTips10": "Жарамсыз SMS рақымдау кodu",
  "editUserInfo.phone": "Телефон нөмірі",


  // Хабарлау баптаулар
  "editUserInfo.noticeTips1": "Хабарлау баптауларын алу сәтсіз!",
  "editUserInfo.noticeTips2": "Хабарлау баптауларын сақтау сәтті!",
  "editUserInfo.noticeTips3": "Батарейя карықтығын азайту хабарламасы",
  "editUserInfo.noticeTips4": "Зарядтау аяқталды хабарламасы",
  "editUserInfo.errorNotification": "Қате хабарламасы",
  "editUserInfo.updateNotification": "Жаңарту хабарламасы",
  "editUserInfo.monthlyStatisticsNotification": "Айлық статистика хабарламасы",
  "editUserInfo.notificationMethod": "Қолдану тәсілі",

  // Пайдаланушы атына байланысты кеңеслер
  "editUserInfo.userNameTips1": "Пайдаланушы атын сақтау сәтті",
  "editUserInfo.userNameTips2": "Пайдаланушы атын сақтау сәтсіз",
  "editUserInfo.userNameTips3": "Пайдаланушы атын енгізіңіз",
  "editUserInfo.userNameTips4": "Жарамсыз пайдаланушы аты форматы: тек сандар, асттагы сызық (_) және латын әріптері պекірілуі мүмкін",
  "editUserInfo.userNameTips5": "Пайдаланушы атын енгізіңіз",
  "editUserInfo.userNameTips6": "Сақталуде... сәл кейініші күте тұрыңыз...",
  "editUserInfo.userName": "Пайдаланушы аты",

  // Профиль суретін өңдеу кеңестері
  "editUserInfo.avatorTips": "Профиль суретін өзгерту үшін басыңыз",
  "editUserInfo.verifyCodeTips1": "Қалпына келтірілген рақымдау кодын енгізіңіз:",
  "editUserInfo.verifyCodeTips2": "Сіздің акаунттың қауіпсіздігі үшін төмендегі түймеге басып, рақымдау кодын бастапқы телефон нөмірінге жіберіңіз:",
  "editUserInfo.verifyCodeTips3": "Код жіберу",
  "editUserInfo.verifyCodeTips4": "Бастапқы телефон нөмірін рақымдау сәтті, байланыстыру үшін жаңа телефон нөмірін енгізіңіз",
  "editUserInfo.verifyCodeTips5": "Сіздің акаунттың қауіпсіздігі үшін төмендегі түймеге басып, рақымдау кодын бастапқы электроны поштаға жіберіңіз:",
  "editUserInfo.verifyCodeTips6": "Бастапқы электроны поштаны рақымдау сәтті, жаңа электроны поштаны енгізіңіз",
  "editUserInfo.verifyCodeTips7": "Ескі құпиясөз",
  "editUserInfo.verifyCodeTips8": "Алдымен электроны поштаны байланыстырыңыз!",
  "editUserInfo.verifyCodeTips9": "Рақымдау кodu электроны поштаға жіберілді, тексерңіз",
  "editUserInfo.verifyCodeTips10": ", автоматты түрде кірүү бетinə өтіледі",

  // Хабарлауға байланысты
  "hems.notice.title": "Хабарлау тақырыбы", 
  "hems.notice.content": "Хабарлау мазмұны", 
  "hems.notice.operate": "Операция",
  "hems.notice.noRead": "Оқыылмаған",
  "hems.notice.read": "Оқыылған",
  "hems.notice.warning": "Ескерткіш",
  "hems.notice.error": "Қате",
  "hems.notice.success": "Статистика есептеу",
  "hems.notice.sys": "Система ақпараты",
  "hems.notice.operateSuccess": "Операция сәтті",
  "hems.notice.operateTips": "Операция үшін элементті таңдаңыз",

  // Басты бет
  "hems.home.selfuseRate": "Өздік пайдалану дүниесі",
  "hems.home.percent": "Пәрценті",
  "hems.home.todayData": "Бүгінгі деректер",
  "hems.home.todayPowerGeneration": "Бүгінгі электр உற்பதасы",
  "hems.home.salesIncome": "Электр сатудан табылған gəlірі",
  "hems.home.saved": "Сіз куттып алдыңыз",
  "hems.home.reduce": "Карбон шығаруын азайту",
  "hems.home.tips1": "Қазір деректер қол жетімді емес, сен әлі xxxx-ні байланыстырмаған",
  "hems.home.criticalLoad": "Қатты жүктеме",
  "hems.home.keyVoltage": "Қатты τάуышы",
  "hems.home.householdLoad": "Әйдіне жүктеме",
  "hems.home.householdVoltage": "Әйдіне τάуышы",
  "hems.home.generalLoad": "Жалпы жүктеме",
  "hems.home.generalVoltage": "Жалпы τάуышы",
  "hems.home.batteryHealth": "Батарейя денсаулық күйі",
  "hems.home.averageTemp": "Орташа температура",
  "hems.home.gridLoad": "Электр желі жүктемесі",
  "hems.home.toggeleDataSource": "Көрсетілген деректер келесі тәрізді өзгертілді:",
  "hems.home.toggleTips": "Өзгертуіңіз келеді ме?",
  "hems.home.modeSending": "Режим командасын жіберуда... сәл кейініші күте тұрыңыз...",
  "hems.home.modeSuccess": "Режим өзгертуі сәтті жіберілді!",
  "hems.home.isOnline": "Сіз онлайнсыз ба?",
  "hems.home.useStatus": "Пайдалану күйі",
  "hems.home.workModeText": "Қазіргі жұмыс режімі:",
  "hems.home.toggleDataSourceText": "Көрсетілген деректер келесі тәрізді өзгертілді:",
  "hems.ev.charge.status": "Зарядтау күйі",
  "hems.ev.charge.time": "Зарядтау уақыты",
  "hems.ev.charge.count": "Достық зарядтау саны (уақыт бойы)",
  "hems.ev.charge.status.empty": "Бос",
  "hems.ev.charge.status.ing": "Батарейяға байланыстырылған. Зарядтауда",
  "hems.ev.charge.status.null": "Батарейяға байланыстырылған, бірақ зарядтауда емес",
  "hems.ev.charge.status.error": "Қате",
  "hems.hour": "Сағат",
  "hems.minue": "Минут",
  "hems.ev.chagre.number": "Зарядғыл нөмірі",

  // Пайдаланушы нұсқаулығы
  "hems.userGuide.selfUse": "Өздік электр உற்பதасын пайдалану",
  "hems.userGuide.selfUseTips": "Алдымен қарапайым энергияны пайдаланыңыз, егер жеткілікті емес болса, электр желімен толтырыңыз",
  "hems.userGuide.economyMode": "Экономикалық режим",
  "hems.userGuide.economyModeTips": "Электр бағасы негізінде энергия пайдалану стратегiyasын оптималдылау",
  "hems.userGuide.emergencyMode": "Түпкіш режим",
  "hems.userGuide.emergencyModeTips": "Қатты жүктемелерге энергия жеткізу нұсқауы",

  // График бет
  "hems.history.energyStatistics": "Энергия статистикасы",
  "hems.history.revenueStatistics": "Гелір статистикасы",
  "hems.history.greenStatistics": "Жасыл шығаруларды азайту",
  "hems.history.revenueTitle": "Электр сатудан жалпы gəlірі",
  "hems.history.savingsTitle": "Жалпы куттып алынған сумма",
  "hems.history.carbonTitle": "Жалпы карбон азайту量",
  "hems.history.day": "Күн",
  "hems.history.month": "Ай",
  "hems.history.year": "Жыл",
  "hems.history.beforeDay": "Алдыңғы күн",
  "hems.history.afterDay": "Келесі күн",
  "hems.history.beforeMonth": "Алдыңғы ай",
  "hems.history.afterMonth": "Келесі ай",
  "hems.history.beforeYear": "Алдыңғы жыл",
  "hems.history.afterYear": "Келесі жыл",
  "hems.history.totalUse": "Жалпы пайдалану量",
  "hems.history.fullScreen": "Толық экран",
  "hems.history.timeSelect": "Күнді таңдаңыз",
  "sync.tips1": "Деректер синхронизациясы командасы сәтті жіберілді!",
  "sync.tips2": "Деректер синхронизациясы жүзеге асырылады, деректер көлемі үлкен болғандықтан уақыт алады, 50 минуттан кейін қайтадан тексерңіз~",
  "sync.tips3": "Құрылғы деректер синхронизациясы кешірілуі мүмкін, егер деректер сәйкес келмейтінді көресіз, төмендегі түймеге басыңыз:",
  "sync.tips4": "Деректерді синхронизациялау",

  // Зарядғыл ақпараты
  "charge.info": "Зарядғыл ақпараты",
  "news.loading": "Жүктелуде...",
  "news.noMore": "Кейінгі деректер жоқ",
  "hems.pv.power": "Карапайым энергия量",

  // UEH арнайы функциялары
  "ueh.sellPower": "Сатылған электр量",
  
  // Меню
  "menu.home": "Басты бет",
  "menu.history": "Тарих деректері",
  "menu.device": "Құрылғылар",
  "menu.settings": "Баптаулар",
  "menu.messageCenter": "Хабарлар орталығы",
  "menu.help": "Нұсқаулар және қолдау",
  "menu.mine": "Менің (жеке)",


  // Менің баптауларым
  "mine.userSetting": "Пайдаланушы баптаулары",
  "mine.terminalSetting": "Бастапқы терминал баптаулары",
  "mine.uploadCloud": "Деректерді бұлтқа жүктеу",
  "mine.changeVersion": "Жаңартуларды тексеру",
  "mine.language": "Тілді өзгерту",
  "mine.about": "Қосымша туралы",
  "mine.feedback": "Кері байланыс",
  "mine.logout": "Шығу",
  "mine.logoutAccount": "Акаунтты өшіру",

  // Акаунтты өшіруге байланысты
  "mine.logoutAccountTips": "[] атты акаунтты өшіру",
  "mine.logoutAccountTips1": "[]-ға байланыстырылған акаунтты өшіру",
  "mine.logoutAccountCare": "Акаунт өшіру сұрауы ескерткіштері:",
  "mine.logoutAccountCare1": "1. Акаунт қауіпсіз күйде",
  "mine.logoutAccountCare1-1": "Акаунт әдеттегі пайдалану күйінде, қорыту, ережелерді бұзудің немесе жабудың қаупігі жоқ",
  "mine.logoutAccountCare2": "2. Акаунтқа кіру құқығы және байланыстырулар өшіріледі",
  "mine.logoutAccountCare2-1": "Өтінші тарап платформаларына арналған барлық акаунтқа кіру құқығылар өшіріледі",
  "mine.logoutAccountCare3": "3. Өшіруден кейін акаунтты қалпына келтіру мүмкін емес, пайдаланушы деректері өшіріледі",
  "mine.logoutAccountCare3-1": "Өшіруден кейін байланыстырылған телефон нөмерлері, электроны пошталар және 관련 деректері өшіріледі және қалпына келтірілелмейді",
  "mine.confirmLogout": "Өшіруді рақымдау",
  "mine.logoutSuccess": "Акаунт сәтті өшірілді!",


  // Кері байланыс проблемалары
  "mine.feedbackIssues": "Проблемалар және кері байланыс",
  "mine.feedQuantity": "Саны",
  "mine.feedAmount": "Ең көп 9 сурет, hər bir surətin maksimum həcmi 1 MB",

  // Хабарлау баптауларına байланысты
  "mine.notice.fail": "Хабарлау баптауларын алу сәтсіз!",
  "mine.notice.saveSuccess": "Хабарлау баптауларын сақтау сәтті!",
  "mine.notice.saveFail": "Сақтау сәтсіз!",
  "mine.notice.title": "Хабарлау баптаулар",
  "mine.notice.batteryLow": "Батарейя карықтығын азайту хабарламасы",
  "mine.notice.chargingFinish": "Зарядтау аяқталды хабарламасы",
  "mine.notice.error": "Қате хабарламасы",
  "mine.notice.update": "Жаңарту хабарламасы",
  "mine.notice.monthly": "Айлық статистика хабарламасы",
  "mine.notice.receiveType": "Қолдану тәсілі",

  // Тіл баптауларına қош келу
  "mine.language.welcome": "SusprSafe-ге қош келдіңіз",
  "mine.language.desc1": "Сіздің тұрақты мекен-жайыңыз негізінде тіл нұсқасын таңдаңыз",
  "mine.language.desc2": "Қосымша баптауларында кез-келген уақытта оны өзгерте аласыз",

  // Жеке ақпараттар
  "mine.userInfo.avatar": "Профиль суреті",
  "mine.userInfo.nickname": "Ыстық аты",
  "mine.userInfo.password": "Құпиясөз",
  "mine.userInfo.changePassword": "Құпиясөзді өзгерту",
  "mine.userInfo.setPassword": "Құпиясөзді орнату",
  "mine.userInfo.phoneNumber": "Телефон нөмірі",
  "mine.userInfo.bindPhone": "Телефонды байланыстыру",
  "mine.userInfo.bindEmail": "Электрондық поштаны байланыстыру",
  "mine.loginExpired": "Кіру сессиясы аяқталды, қайтадан кіріңіз",
  "mine.userInfo.title": "Пайдаланушы ақпараттары",
  "mine.userInfo.bind": "Байланыстыру",
  "mine.userInfo.modify": "Өңдеу",
  "mine.userInfo.modifyNickname": "Ыстық атыны өзгерту",
  "mine.userInfo.userNickname": "Пайдаланушының ыстық аты",
  "mine.userInfo.selectPic": "Жүктеу үшін суретті таңдаңыз",
  "mine.userInfo.saveSuccess": "Сақтау сәтті",
  "mine.userInfo.uploadFail": "Жүктеу сәтсіз",
  "mine.userInfo.avatarSaveSuccess": "Профиль суретін сақтау сәтті",
  "mine.userInfo.nameTips1": "Ыстық ат өрісі бос болмауы керек",
  "mine.userInfo.nameTips2": "Ыстық атын енгізіңіз",

  // Жалпы таңдау кеңестері
  "common.pleaseSelect": "Таңдаңыз",
  "question.commonQuestions": "Жаңа сұрақтар",
  "account.toggleLanguage": "Тілді өзгерту",
  "account.localConnection": "Локальный қосылым",
  "account.selectLanguage": "Тілді таңдаңыз",
  "account.sendEmailToast": "Рақымдау кodu xxx электроны поштаға жіберілді, тексерңіз",
  "account.emailError": "Жарамсыз электроны пошта форматы",
  "account.sendEmailFail": "Жіберу сәтсіз, қайтадан көріңіз",
  
  "common.submitting": "Жіберілуда... сәл кейініші күте тұрыңыз...",

  "device.page.noData": "Қазір деректер қол жетімді емес, бұл бет тек қосымшадан көрсетілуі мүмкін"
,

  // OTA Upgrade
  "bmsFirmware.upgrade": "Upgrade",
  "bmsFirmware.upgrading": "Upgrading...",
  "bmsFirmware.uploadingFile": "Uploading firmware file...",
  "bmsFirmware.upgradingProgress": "Upgrading firmware... {progress}%",
  "bmsFirmware.upgradeSuccess": "Upgrade Successful",
  "bmsFirmware.upgradeSuccessSubtitle": "BMS firmware upgrade completed!",
  "bmsFirmware.upgradeFailed": "Upgrade Failed",
  "bmsFirmware.upgradeFailedFormError": "Please check if the form is filled correctly",
  "bmsFirmware.upgradeFailedNetworkError": "Network error, please retry",
  "bmsFirmware.invalidFileType": "Please select a valid firmware file (.bin, .hex, .fw, .firmware)",
  "bmsFirmware.selectFileWarning": "Please select a firmware file first",
  "bmsFirmware.statusUpgrading": "Upgrading",
  "bmsFirmware.statusCompleted": "Upgrade Completed",
  "bmsFirmware.statusFailed": "Upgrade Failed",
  "bmsFirmware.deviceUpgrading": "Upgrading firmware package, upgrade takes 30 ~ 50 minutes, real-time device data cannot be viewed during this period, please wait...",
  "bmsFirmware.upgradeStatusLabel": "Upgrade Status",
  "bmsFirmware.upgradeProgressLabel": "Upgrade Progress",
  "bmsFirmware.currentPackageLabel": "Current transmitted data package number",
  "bmsFirmware.totalPackagesLabel": "Total data packages",
  "bmsFirmware.upgradeFailedCheckDevice": "Please check device status and retry upgrade",

  // Setting Result Dialog Translations
  "settingResult.defaultTitle": "Setting Successful",
  "settingResult.defaultSubTitle": "Parameter settings saved",
  "settingResult.confirmButton": "OK"
};